module.exports = __webpack_public_path__ + "static/img/school-7.070f567.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-7.png
// module id = wCXC
// module chunks = 0